var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.location)?_c('div',{staticClass:"cp-usage"},[_c('report-usages-list',{attrs:{"location-id":_vm.location?.id,"show-no-energy":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }